
import config from "../assets/config";
import menuLateral from "@/components/menu-lateral";
import dialogReload from "@/components/dialogReload";
import { mapMutations } from "vuex";
import { common } from "@/mixins/common";
import { proyecto } from "@/mixins/proyecto.mixins.js";

export default {
  mixins: [common, proyecto],
  components: { menuLateral, dialogReload },
  head() {
    return {
      titleTemplate: "%s - " + this.proyecto_v.codetitle,
      meta: [{ hid: "description", name: "description", content: this.proyecto_v.descripcion }],
    };
  },
  beforeMount() {
    this.load();
    this.year = this.$moment().format("YYYY");
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    this.drawer = this.windowWidth >= 960;
    this.setStateData({ key: "size", value: this.windowWidth });
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
      this.setStateData({ key: "size", value: this.windowWidth });
    };
    // Si en otra pestaña se inicia/cierra sesión (cambia el token compartido
    // en localStorage), esta pestaña queda con una identidad mezclada:
    // recargar para sincronizarla con la sesión vigente.
    this.tokenSesion = this.getStateCookie(config.cookie.token);
    window.addEventListener("storage", this.onSesionCambiada);
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.onSesionCambiada);
  },
  computed: {
    isMobile() {
      return this.windowWidth < 960;
    },
    drawerWidth() {

      if (this.menuExpanded) {
        return 220;
      }
      return 60;
    },
    dispositivo() {
      let p = "md";
      if (this.windowWidth < 600) { p = "xs"; }
      if (this.windowWidth >= 600 && this.windowWidth < 960) p = "sm";
      if (this.windowWidth >= 960 && this.windowWidth < 1264) p = "md";
      if (this.windowWidth >= 1264 && this.windowWidth < 1904) p = "lg";
      if (this.windowWidth >= 1904) p = "xl";
      this.setStateData({ key: "pantalla_dispositivo", value: p });
      return p;
    },
    iconUrl() { return this.url_logo; },
    user_name() {
      return this.getStateCookie(config.cookie.username) || "";
    },
    entity_name() {
      let user = this.getStateData("user");
      let entidad = user ? user.entity : undefined;
      return entidad ? entidad.name : "";
    }
  },
  data: () => ({
    app: config.APP,
    profile: config.router.profile,
    content: false,
    drawer: true,
    showDialogReload: false,
    validating: true,
    year: null,
    windowWidth: 700,
    pv_id: null,
    mini: true,
    logoLoaded: true,
    menuExpanded: false,
    tokenSesion: null,
  }),
  methods: {
    ...mapMutations(["setRole", "setRules", "setTargets"]),
    onSesionCambiada(event) {
      // key === null: localStorage.clear() desde otra pestaña (logout)
      const tokenCambio =
        event.key === config.cookie.token && event.newValue !== this.tokenSesion;
      if (event.key === null || tokenCambio) {
        window.location.reload();
      }
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    onMenuExpandedChange(expanded) {
      this.menuExpanded = expanded;
    },
    async load() {
      try {
        this.validating = true;
        const token = this.getStateCookie(config.cookie.token);
        if (token != undefined) {
          this.showDialogLoader = true;
          await this.cargarUsuario(token);
          await this.cargarProyectoVainilla();
          this.content = true;
          this.validating = false;
          this.showDialogLoader = false;
        } else {
          this.$router.push(config.router.login);
        }
      } catch (e) { this.$router.push(config.router.login); }
    },
    async cargarUsuario(token) {
      const url = config.api.url + "valid";
      this.$axios.setHeader("Cache-Control", "no-cache");
      this.$axios.setHeader("web-key", config.web_key);
      const { data } = await this.$axios.get(url, this.getOptions());
      const user = data.info;
      this.$axios.setHeader("token", token);
      this.$axios.setHeader("user-id", user.uid);
      this.setStateData({ key: config.store.user, value: user });
      this.setRole(user.doctrade);
      this.setRules(user.rules);
      this.setTargets(Object.keys(user.rules));
    },
    async cargarProyectoVainilla() {
      // Esperar el branding de la entidad antes de mostrar el contenido: sin
      // el await se alcanzaba a ver el logo/nombre de la sesión anterior.
      try { this.pv_id = this.getStateCookie(config.cookie.entity); await this.$store.dispatch("loadPV", this.pv_id); }
      catch (e) { }
    },
    exit() {
      try {
        const token_cuenta = this.$cookie.get("token_cuenta");
        if (token_cuenta != undefined) this.$cookie.delete("token_cuenta");
        const destino = config.router.login + this.pv_id;
        // Eliminar todo rastro persistente (cookies + localStorage) y cerrar
        // el socket; luego navegación dura: recarga completa de la app para
        // que ningún estado en memoria sobreviva al cierre de sesión.
        this.$store.commit("resetSocket");
        this.$store.commit("resetCookie");
        window.location.href = destino;
      } catch (e) { console.error(e); }
    },

    /**
     * Manejar error al cargar el logo
     */
    onLogoError() {
      this.logoLoaded = false;
      console.warn("No se pudo cargar el logo, mostrando icono de usuario por defecto");
    },

    /**
     * Manejar carga exitosa del logo
     */
    onLogoLoad() {
      this.logoLoaded = true;
    },
  },
};
